import './test-reports.scss';

import React from 'react';

import { graphql } from 'gatsby';
import { useTranslation } from 'react-i18next';

import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { GetDocDisplayName } from '../utils/GetDocDisplayName';

export const query = graphql`
    query {
        about: allProductsJson(filter: { code: { eq: "occ_test-reports" } }) {
            nodes {
                code
                documents {
                    en_CA
                    en_US
                    fr_CA
                    caption {
                        en_CA
                        en_US
                        fr_CA
                    }
                }
                attributes {
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
    }
`;

export default function TestReports(props: { data: any }) {
    const { data } = props;

    const { t } = useTranslation('layout');
    const { currentLocale } = usePageLocalization();
    const testReports = data.about.nodes[0]?.documents;
    const metadataAttributes = data?.metadata?.nodes[0]?.attributes;
    const metadata = {
        title: metadataAttributes?.meta_title?.values[0][currentLocale],
        description:
            metadataAttributes?.meta_description?.values[0][currentLocale],
    };

    return (
        <Layout>
            <SEO title={metadata?.title} description={metadata?.description} />
            <div className='container testReports'>
                <div id='primary'>
                    <h1 className='title'>{t('navigation.testing-reports')}</h1>
                    <hr />
                    <ul>
                        {testReports?.map((element, i) => {
                            return (
                                <li key={`testreport-${i}`}>
                                    <a
                                        rel='noreferrer'
                                        target='_blank'
                                        href={`/file/${element[currentLocale]}`}
                                        className='document'
                                    >
                                        {GetDocDisplayName(element)}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </Layout>
    );
}
